import React, { useRef, useEffect, useState } from 'react';
import { Bar ,Line} from "react-chartjs-2";


const StackedGraph = ({ data,serviceColors}) => {
  const svgRef = useRef();
 // const colors =["#95A4FC","#BAEDBD","#C5B0F6","#FC9778"]
  const [monthsLabels,setMonthsLabels]=useState([])
  const [monthsRevered,setMonthsReversed]=useState([])
  const [colors,setColors]=useState({})
  const [services,setServices]=useState({})

  const colorValues = {
    'Super Market' : "#B1E3FF",
    'Pharmacy':"#F760EF",
    'Jewellery' : "#1C1C1C",
    'Restaurants' : "#95A4FC"
  }

  useEffect(() => {
    let monthsArray = []
    data.map((d)=> {
      let months = d?.month 
      monthsArray.push(months)
  })
  setMonthsLabels(monthsArray)
  if(serviceColors !== undefined){
    setColors(serviceColors)
  }
 }, [serviceColors])


 useEffect(() => {
  if(monthsLabels !== undefined){
 let reverseMonths = monthsLabels.reverse()
 setMonthsReversed(reverseMonths)
  }
}, [monthsLabels])

useEffect(() => {
  if(serviceColors !== undefined){
    let myObject = {}
    let serviceKey = {}

    serviceColors.map((data) => {
      myObject[data?.service_name] = data?.color;
      serviceKey[data?.service_name] = 0
    })
    setColors(myObject)
    setServices(serviceKey)
  }

}, [serviceColors])




  const options = {
    scales: {
        y: {
            border:{dash: [4, 4]}, // for the grid lines
            grid: {
                color: '#aaa', // for the grid lines
                tickColor: '#000', // for the tick mark
                tickBorderDash: [2, 3], // also for the tick, if long enough
                tickLength: 10, // just to see the dotted line
                tickWidth: 2,
                offset: true,
                drawTicks: true, // true is default 
                drawOnChartArea: true // true is default 
            },
            stacked: true,
            beginAtZero: true,
            ticks: {
              color: 'black' // Change the color of x-axis labels here
            }
        },
        x: {
            display: true,
            stacked: true,
            ticks: {
              color: 'black' // Change the color of x-axis labels here
            }
        }
    },
    plugins: {
      legend: {
        display: false, // Hide dataset labels
      },
    },
    maintainAspectRatio: false, // Make the chart responsive
    responsive: true, // Enable responsiveness
};
  
   
  const stackedData = {
    labels:monthsRevered,
    datasets: Object.keys(services).map(service => ({
      label: service,
      data: monthsRevered.map(month => {
        const monthData = data.find(item => item.month === month);
        return monthData ? monthData.type_counts[service] || 0 : 0;
      }),
      stack: 'Stack 0', // Set the same stack ID for all datasets
       backgroundColor: colors != undefined? colors[service] : [],
      //backgroundColor: colors.map((item) =>{ console.log("item2",item)}),
    })).reverse(),
    
   
  };



  return (

    <div  >
<Bar data={stackedData} options={options} style={{height:"300px",width:"100%"}} />
    </div>  
  );
};

export default StackedGraph;